import React from "react";
import "./Pricing.css";

const Pricing = () => {
  return (
    <section className="pricing-section">
      <h2 className="section-title">💸 Prissättning</h2>
      <div className="pricing-cards">

        {/* E-Bok */}
        <div className="card">
          <h3>📘 E-bok</h3>
          <p className="price">499 €</p>
          <ul>
            <li>Full e-bok: “Starta din Dropshippingresa”</li>
            <li>Beprövade strategier & checklistor</li>
            <li>Perfekt för dig som gillar att köra själv</li>
          </ul>
          <a href="https://school.emacademy.se/p/e-bok-dropshipping" className="cta-button">📥 Ladda ner</a>
        </div>

        {/* Kurs */}
        <div className="card popular">
          <div className="tag">Mest populär</div>
          <h3>🎓 Kurs</h3>
          <p className="price">2 500 €</p>
          <ul>
            <li>Full dropshippingkurs (livstidsaccess)</li>
            <li>6+ timmar video, mallar & resurser</li>
            <li>Passar dig som vill bygga seriöst</li>
          </ul>
          <a href="https://school.emacademy.se/p/dropshippingkurs" className="cta-button">🚀 Starta nu</a>
        </div>

        {/* Mentorskap */}
        <div className="card">
          <h3>🤝 Mentorskap</h3>
          <p className="price">4 500 €</p>
          <ul>
            <li>1–1 coaching direkt med Tony</li>
            <li>Feedback på butik & annonser</li>
            <li>Prioriterad DM-support & Discord</li>
          </ul>
          <a href="https://school.emacademy.se/p/mentorskap" className="cta-button">🔒 Ansök nu</a>
        </div>

      </div>
    </section>
  );
};

export default Pricing;
